import { render, staticRenderFns } from "./cadtabelasprecos.vue?vue&type=template&id=cf873760&"
import script from "./cadtabelasprecos.vue?vue&type=script&lang=js&"
export * from "./cadtabelasprecos.vue?vue&type=script&lang=js&"
import style0 from "./cadtabelasprecos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports